import { AD_UNIT_IDS } from '@/constants/ad';

import type { NativeAdSlotConfig as AdSlotConfig } from './NativeAdSlot';

//* 고정 위치 광고 슬롯의 단일 카탈로그 — unitId·사이즈·rounded가 여기 한 곳에만 산다.
//* 사이즈를 컴포넌트마다 박지 않으므로 슬롯 간 사양을 한눈에 비교/감사할 수 있다.
//* (검색 결과 슬롯은 위치 규칙이 얽혀 있어 searchAdPlacements.ts에서 따로 관리)
export const AD_PLACEMENTS = {
  //* 피드홈
  homeFeedBanner: {
    unitIdM: AD_UNIT_IDS.HOME_FEED_LIST_BANNER_M,
    unitIdP: AD_UNIT_IDS.HOME_FEED_LIST_BANNER_P,
    mWidth: 320,
    mHeight: 50,
    pWidth: 600,
    pHeight: 314,
  },
  homeFeedNative: {
    unitIdM: AD_UNIT_IDS.HOME_FEED_NATIVE_M,
    unitIdP: AD_UNIT_IDS.HOME_FEED_NATIVE_P,
    mWidth: 375,
    mHeight: 590,
    pWidth: 600,
    pHeight: 780,
  },
  homeSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.HOME_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 250,
    pHeight: 250,
    rounded: 'large',
  },

  //* 통합검색 상단
  searchTopBanner: {
    unitIdM: AD_UNIT_IDS.SEARCH_TOP_M,
    unitIdP: AD_UNIT_IDS.SEARCH_TOP_P,
    mWidth: 375,
    mHeight: 163,
    pWidth: 728,
    pHeight: 90,
  },
  searchSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.SEARCH_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 250,
    pHeight: 250,
    rounded: 'large',
  },

  //* 정책활용가이드 상세
  policyGuideTop: {
    unitIdM: AD_UNIT_IDS.POLICY_GUIDE_TOP_M,
    unitIdP: '', //* PC는 콘솔 ID 미발급 — 발급 시 채우면 자동 활성
    mWidth: 375,
    mHeight: 163,
    pWidth: 375,
    pHeight: 163,
  },
  policyGuideBottom: {
    unitIdM: AD_UNIT_IDS.POLICY_GUIDE_BOTTOM_M,
    unitIdP: AD_UNIT_IDS.POLICY_GUIDE_BOTTOM_P,
    mWidth: 335,
    mHeight: 250,
    pWidth: 560,
    pHeight: 250,
    rounded: 'medium',
  },
  policyGuideSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.POLICY_GUIDE_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 250,
    pHeight: 250,
    rounded: 'large',
  },

  //* 상세 본문 하단 배너 (MO/PC 동일 단일 유닛)
  contentDetailBottom: {
    unitIdM: AD_UNIT_IDS.CONTENT_DETAIL_BOTTOM_BANNER,
    unitIdP: AD_UNIT_IDS.CONTENT_DETAIL_BOTTOM_BANNER,
    mWidth: 300,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },
} as const satisfies Record<string, AdSlotConfig>;
